var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 4.5L4.5 13.5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#101010"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.5 4.5L13.5 13.5",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#101010"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXDark);
export default __webpack_public_path__ + "static/media/icon-x-dark.05b71dcd888bc55de2fbbcd2245e9c7f.svg";
export { ForwardRef as ReactComponent };